import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dbffeae"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { signoutUser } from '@/composables/auth';
import { RoutesNames } from '@/router/routesNames';
import { useRouter } from 'vue-router';
import { withDefaults } from 'vue';
import { User, Company, CurrentAppVisualizationType } from '@/graphql/types/graphql';
import { useUserStore } from '@/store/user';
import { useChangeCurrentAppVisualizzation } from '@/composables/user';
import { useI18n } from 'vue-i18n';
import { isSmallDevice } from '@/utils/helpers';
import { EnvVars, getEnv } from '@/utils/env';

interface UserMenuProps {
    user: User;
    company: Company;
    isTalent: boolean;
    theme: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfileMenu',
  props: {
    user: { default: null },
    company: {},
    isTalent: { type: Boolean, default: true },
    theme: { default: 'white' }
  },
  setup(__props: any) {

const { t } = useI18n();
const router = useRouter();
const userStore = useUserStore();

const {
    mutate: changeCurrentAppVisualizzation,
    loading: loadingUpdate,
    onDone: onDonechangeCurrentAppVisualizzation,
} = useChangeCurrentAppVisualizzation();

const props = __props;

function goToUserProfile() {
    const id = getUserId();
    router.push({
        name: RoutesNames.user_profile,
        params: { id },
    });
}

function getUserId() {
    return props.user ? props.user.id : null;
}

function getImageProfile() {
    const image = props.user && props.user.photo ? props.user.photo.fileName : null;
    return image;
}

function getButtonColor() {
    const color = props.theme === 'white' ? 'lightGray' : 'white';
    return color;
}

function getTextIconColor() {
    const color = props.theme === 'white' ? 'subtitle' : 'white';
    return color;
}

function hasCompany() {
    return userStore.allCompanies?.length > 0;
}
function approved() {
    return !!companyApproved() && !!userApproved();
}

function companyApproved() {
    return !!userStore.currentCompany?.company_approval_date;
}

function userApproved() {
    return (
        !!userStore.currentCompany?.user_approval_date &&
        userStore.currentCompany.user_approval_date !== ''
    );
}

function actionViewType(withAdd) {
    if (!hasCompany() && withAdd) {
        return t('add_company');
    }
    return userStore.viewTypeUser ? t('view_type_company') : t('view_type_user');
}

function getCompanyId() {
    return props.company ? props.company.companyId : null;
}

function openRecruiting() {
    window.location.href = getEnv(EnvVars.VUE_APP_DOMAIN) + '/dashboard';
}

onDonechangeCurrentAppVisualizzation(() => {
    router.replace({ name: RoutesNames.dashboard });
});

async function changeViewType() {
    let companyId = getCompanyId();

    if (!companyId) {
        const allCompanies = userStore.allCompanies;
        if (allCompanies && allCompanies.length > 0) {
            companyId = allCompanies[0].companyId;
        }
    }

    const payload: any = {
        type: userStore.viewTypeUser
            ? CurrentAppVisualizationType.Company
            : CurrentAppVisualizationType.User,
    };

    if (payload.type === CurrentAppVisualizationType.Company) {
        payload.companyId = companyId;
    }

    await changeCurrentAppVisualizzation(payload);
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, { class: "menu-custom" }, {
    activator: _withCtx(({ props: activatorProps }) => [
      (props.isTalent)
        ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
            key: 0,
            color: getButtonColor()
          }, activatorProps, {
            elevation: "0",
            rounded: "pill",
            variant: "outlined"
          }), {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: getTextIconColor(),
                class: "mr-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-menu")
                ]),
                _: 1
              }, 8, ["color"]),
              _createVNode(_component_v_avatar, { size: "x-small" }, {
                default: _withCtx(() => [
                  (getImageProfile())
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        style: {"height":"100%"},
                        src: getImageProfile()
                      }, null, 8, _hoisted_1))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        size: "x-large",
                        color: getTextIconColor()
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" mdi-account-circle ")
                        ]),
                        _: 1
                      }, 8, ["color"]))
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040, ["color"]))
        : _createCommentVNode("", true),
      (!props.isTalent)
        ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 1 }, activatorProps, {
            color: getButtonColor(),
            elevation: "0",
            rounded: "pill",
            variant: "outlined",
            size: "small",
            class: "font",
            icon: ""
          }), {
            default: _withCtx(() => [
              _createVNode(_component_v_avatar, { size: "small" }, {
                default: _withCtx(() => [
                  (getImageProfile())
                    ? (_openBlock(), _createBlock(_component_v_img, {
                        key: 0,
                        style: {"height":"100%"},
                        src: getImageProfile()
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        color: getTextIconColor(),
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" mdi-account ")
                        ]),
                        _: 1
                      }, 8, ["color"]))
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040, ["color"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, {
        class: "font",
        style: {"margin-left":"-50px"}
      }, {
        default: _withCtx(() => [
          (
                    _unref(userStore).allCompanies.length > 0 &&
                    ((!_unref(userStore).viewTypeUser && !!approved()) || _unref(userStore).viewTypeUser)
                )
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 0,
                class: "cursor",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (changeViewType(true)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, { class: "text-body-2 font-weight-bold text-secondary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(actionViewType(true)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_list_item, {
            onClick: goToUserProfile,
            class: "cursor"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, { class: "text-body-2 text-secondary" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('profile')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_unref(userStore).viewTypeUser)
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 1,
                onClick: openRecruiting,
                class: "cursor"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, { class: "text-body-2 text-secondary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('open_recruiting')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_list_item, {
            onClick: _unref(signoutUser),
            class: "cursor"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, { class: "text-body-2 text-secondary" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('exit')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})